export default "__VITE_ASSET__CSfRWY9X__"